// @flow

import _ from 'lodash/fp';
import React from 'react';
import Linkify from 'react-linkify';
import {
  productPrice,
  productUnit,
} from '../../helpers/priceHelpers';
import ModalDialog from '../ModalDialog/ModalDialog';
import CustomerImageGallery from '../CustomerImageGallery/CustomerImageGallery';
import FormattedPrice from '../FormattedPrice/FormattedPrice';
import CustomerProductOrderButton from '../CustomerProductOrderButton/CustomerProductOrderButton';
import './CustomerProductDialog.css';
import {getVariantOptions} from '../CustomerProductCard/CustomerProductCard';
import {DEMO} from '../../roles.js';

export type Props = {
  product: Object,
  variant: Object,
  activeImage: ?any,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  onImageSelect: Function,
  onClose: Function,
  enabled: boolean,
  activeSelection: Object,
  userRole: Number,
};

const CustomerProductDialog = ({
  product,
  variant,
  activeImage,
  onSelectProduct,
  onRemoveProduct,
  onImageSelect,
  onClose,
  enabled,
  activeSelection,
  userRole,
}: Props) => {
  const {
    variantEnabled,
    isDefault,
    isSelected,
    variantConfig,
    showWarning,
  } = getVariantOptions(activeSelection, enabled, product, variant);
  return (
    <div>
      <ModalDialog
        onClose={() => onClose()}
        showCloseButton={true}
        className="CustomerProductDialog"
        show={true}>
        <div className="product-container">
          <div className="column medium-7 relative">
            <div className="row product-images">
              <div className="image-gallery">
                <CustomerImageGallery
                  activeImage={activeImage}
                  onImageSelect={onImageSelect}
                  images={variant.images} />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="name">
              {product.name} - {variant.name}
            </div>
            <div className="product-info">
              {variant.replacement &&
                <div className="section">
                  <div className="callout warning text-center">
                    <div>Den här produkten har ersatts av:</div>
                    <div>
                      {variant.replacement.productName} - {variant.replacement.variantName}
                    </div>
                  </div>
                </div>
              }
              {(!variant.replacement && (product.archived || variant.archived)) &&
                <div className="section">
                  <div className="callout warning text-center">
                    <div>Den här produkten har utgått</div>
                  </div>
                </div>
              }
              <div className="section">
                {isDefault &&
                  <div className="label">
                    Standard
                  </div>
                }
                <div className="itemNumber">
                  Artnr. {variant.itemNumber}
                </div>
              </div>
              {!isDefault && (!activeSelection.slot.advanced || !!variantConfig) &&
                <div className="section price">
                  <span>Pris: <FormattedPrice
                    value={productPrice(
                      variant,
                      activeSelection.slot,
                      activeSelection.orderRow,
                      variantConfig,
                      activeSelection.config,
                    )}
                    unit={productUnit(
                      variant,
                      activeSelection.slot,
                      activeSelection.orderRow,
                      variantConfig,
                      activeSelection.config,
                    )} /></span>
                </div>
              }
              {(!_.isEmpty(variant.externalDescription) || !_.isEmpty(product.externalDescription)) &&
                <Linkify
                  className="section description"
                  properties={{target: '_blank'}}>
                  {!_.isEmpty(product.externalDescription) &&
                    <p className="preserve-whitespace">{product.externalDescription}</p>
                  }
                  {!_.isEmpty(variant.externalDescription) &&
                    <p className="preserve-whitespace">{variant.externalDescription}</p>
                  }
                </Linkify>
              }
              {(!_.isEmpty(variant.color)
                || !!variant.sizeWidth
                || !!variant.sizeHeight
              || !!variant.sizeDepth) &&
                <div className="section specifications">
                  <table>
                    <tbody>
                      {!_.isEmpty(variant.color) &&
                        <tr>
                          <td>Färg</td>
                          <td>{variant.color}</td>
                        </tr>
                      }
                      {!!variant.sizeWidth &&
                        <tr>
                          <td>Bredd</td>
                          <td>{variant.sizeWidth} cm</td>
                        </tr>
                      }
                      {!!variant.sizeHeight &&
                        <tr>
                          <td>Höjd</td>
                          <td>{variant.sizeHeight} cm</td>
                        </tr>
                      }
                      {!!variant.sizeDepth &&
                        <tr>
                          <td>Djup</td>
                          <td>{variant.sizeDepth} cm</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              { userRole !== DEMO &&
                <div className="section">
                  <CustomerProductOrderButton
                    isOrdered={isSelected}
                    onSelectProduct={() => onSelectProduct(variant)}
                    onRemoveProduct={() => onRemoveProduct(variant)}
                    enabled={variantEnabled}
                    showWarning={showWarning} />
                </div>}
            </div>
          </div>
        </div>
        { userRole !== DEMO && isSelected &&
          <div className="ribbon">
            <i className="fa fa-check-circle-o" />
          </div>
        }
      </ModalDialog>
    </div>
  );
};

export default CustomerProductDialog;



// WEBPACK FOOTER //
// ./src/components/CustomerProductDialog/CustomerProductDialog.js